/**
 * Diretiva responsável por validar se o valor de um campo é igual ao valor de um segundo
 * campo. Pode ser utilizada na validação de campos de confirmação de senhas. 
 */

angular.module("avlib").directive("avPwdConfirm", function() {
	return {
		require: "ngModel",
		scope: {
			otherModelValue: "=avPwdConfirm"
		},
		link: function(scope, element, attributes, ngModel) {
			 
			ngModel.$validators.avPwdConfirm = function(modelValue) {
				return modelValue == scope.otherModelValue;
			};
 
			scope.$watch("otherModelValue", function() {
				ngModel.$validate();
			});
		}
	};
});
